<template>
  <div id="bar"
       :style="size">
    <e-charts :size="size"
              style="margin-top:60px;overflow: hidden"
              :options="options" />
  </div>
</template>

<script>
import ECharts from './ECharts'
import * as echarts from 'echarts'

export default {
  components: {
    ECharts,
  },
  props: {
    monthlyTime: {
      // 月份
      type: Object,
      default: () => ({}),
    },
    monthlyWeight: {
      // 净重
      type: Object,
      default: () => ({}),
    },
  },
  created() {},
  data: function () {
    return {
      year: 2000,
      // 基础柱状图
      options: {
        tooltip: {
          // trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          containLabel: true,
        },
        legend: {
          textStyle: {
            color: 'white',
          },
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: 'white',
              },
            },
            axisLabel: {
              // 展示角度
              rotate: 30,
              /* formatter: val => {   // x轴数据格式化
                return val+'月'
              }*/
            },
            axisTick: {
              // y轴刻度线
              show: false,
            },
            name: '月份 ',
            type: 'category',
            data: JSON.parse(JSON.stringify(this.monthlyTime)),
          },
        ],
        yAxis: [
          {
            name: '净重',
            axisLine: {
              lineStyle: {
                color: 'white',
              },
            },
            axisTick: {
              // y轴刻度线
              show: false,
            },
            splitLine: {
              show: true, // 网格线
              lineStyle: {
                type: 'dashed',
              },
            },
            type: 'value',
          },
        ],
        series: [
          {
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: {
                    // 数值样式
                    color: 'white',
                    fontSize: 12,
                  },
                },
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 0, color: '#00c6ff' },
                  { offset: 1, color: '#0072ff' },
                ]),
              },
            },
            name: '净重',
            type: 'bar',
            emphasis: {
              focus: 'series',
            },
            data: JSON.parse(JSON.stringify(this.monthlyWeight)),
          },
        ],
      },
      size: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '600px',
      },
    }
  },
}
</script>

<style scoped>
</style>
